import React from 'react';

import './ComboItem.css';

const ComboItem = ({ title, price, items }) => (
    <div className='app__menuitem'>
      <div className='app__menuitem-head'>
        <div className='app__menuitem-name' >
          <p className='p__cormorant' style={{ color: '#DCCA87', fontSize: '35px', paddingTop: '10px', paddingBottom: '0px'}}>{title}</p>
        </div>
  
        <div className='app__menuitem-dash'></div>
  
        <div className='app__menuitem-price'>
          <p className='p__cormorant' style={{fontSize: '27px'}}>{price}</p>
        </div>
      </div>
  
      <div className='app__menuitem-sub'>
        <ul>
          {items.map((item, index) => (
            <li key={index}>{item}</li>
          ))}
        </ul>
      </div>
    </div>
  );
  

export default ComboItem;